import React from 'react'
import PropTypes from 'prop-types';
import ReactPasswordStrength from 'react-password-strength';

const  PasswordStrength = ({ name, value, onChange }) => {

  const handleChange = e => {
    
    onChange({
     target: {
       name,
       value: e[name]
     } 
    })
  }

  return (
    <ReactPasswordStrength
      className="!border !border-gray-300"
      minLength={8}
      minScore={3}
      changeCallback={handleChange}
      inputProps={{ name, autoComplete: "off", value, placeholder: "-"  }}
    />
  )
}

PasswordStrength.defaultProps = {
  value: '',
  onChange: () => {}
}

PasswordStrength.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.number,
  onChange: PropTypes.instanceOf(Function)
}

export default PasswordStrength
